const dismissalKey = (controlLastModified: string) =>
  `cc:canaryModalDismissed:${controlLastModified}`;

export const hasDismissedCanaryModal = (controlLastModified: string) =>
  localStorage.getItem(dismissalKey(controlLastModified)) === '1';

export const dismissCanaryModal = (controlLastModified: string) =>
  localStorage.setItem(dismissalKey(controlLastModified), '1');

const sessionAcknowledgementKey = (controlLastModified: string) =>
  `cc:canaryModalAcknowledged:${controlLastModified}`;

// sessionStorage survives client-side navigation (component unmount/remount) but clears
// when the browser tab/session ends, so a plain "Got it" only holds for the current session.
export const hasAcknowledgedCanaryModalThisSession = (
  controlLastModified: string,
) =>
  sessionStorage.getItem(sessionAcknowledgementKey(controlLastModified)) ===
  '1';

export const acknowledgeCanaryModalForSession = (controlLastModified: string) =>
  sessionStorage.setItem(sessionAcknowledgementKey(controlLastModified), '1');
